import React, { useState } from "react";

import * as _ from "lodash";
import styled from "styled-components";

import BackgroundImageComponent from "app/components/bgImage/BackgroundImageComponent";
import ColorStack from "app/components/colorsStack/ColorStack";
import { useSelectorTrigger } from "app/components/filters-bar/useSelectorTrigger";
import { TitleContainer } from "app/components/React/Widgets/WidgetsTop";
import { WidgetFooter } from "app/components/widget/WidgetFooter";
import { StyledSubtitle } from "app/components/widget-title/StyledComponents";
import { CHART_COLORS } from "app/constants/ChartColors";
import { i18nFilter } from "app/filters/i18nFilter";
import { abbrNumberFilter } from "app/filters/ngFilters";
import { NoData, TableLoader } from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";
import { ChartMarkerService } from "app/services/ChartMarkerService";
import durationService, { BasicDurations } from "app/services/DurationService";
import { DefaultFetchService } from "app/services/fetchService";
import { isAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import Chart from "pro-features/components/Chart/src/Chart";

import { generateLastMonthSubtitleFilters } from "../utlis";

const ComponentContainer = styled.div`
    padding: 24px;
`;

const EndPoint = "widgetApi/TrafficSourcesSearchV2/BrandedKeywords/WebsitePerformance/PieChart";
const TitleKey = "wwo.searchTraffic.organic.brandedVsNotBranded.title";
const MonthlyTimeGranularity = "Monthly";
const ToolTipKey = "wwo.searchTraffic.organic.brandedVsNotBranded.title.tooltip";
const mainColors = new ColorStack(CHART_COLORS.mobileWeb);
const CtaButtonText = "wwo.searchTraffic.organic.brandedVsNotBranded.cta.button";
const ButtonTrackingText = "wwo search traffic/branded non branded/ organic";

const pie = function (options, data) {
    const format = abbrNumberFilter(),
        innerSize = "60%",
        size = "85%";
    let timeoutId = null;

    return {
        series: data,
        options: {
            credits: { enabled: false },
            chart: {
                type: "pie",
                animation: false,
                spacing: [0, 0, 0, 0],
                marginBottom: 0,
                marginTop: 10,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                backgroundColor: "transparent",
                height: 180,
                isDirtyLegend: true,
                isDirtyBox: true,
                events: {
                    // enable data labels on export: workaround for https://github.com/highslide-software/highcharts.com/issues/1562
                    load() {
                        if (this.options.chart.forExport) {
                            _.each(this.series, function (series) {
                                series.update(
                                    {
                                        dataLabels: {
                                            enabled: true,
                                        },
                                    },
                                    false,
                                );
                            });
                            this.redraw();
                        }
                        setTimeout(() => {
                            //fix for chart width
                            try {
                                this.reflow();
                            } catch (e) {}
                        }, 1000);
                    },
                },
            },
            title: { text: null },
            legend: {
                layout: "vertical",
                align: "right",
                verticalAlign: "middle",
                symbolWidth: 0,
                symbolRadius: 0,
                symbolHeight: 0,
                squareSymbol: false,
                itemMarginTop: 2,
                itemMarginBottom: 2,
                padding: 0,
                margin: 0,
                useHTML: true,
                itemStyle: {
                    cursor: "text",
                    color: "#2b3d52",
                    fontFamily: "Roboto, sans-serif",
                    zIndex: -1,
                    textOverflow: null,
                },
                x: -50,
                y: 0,
                labelFormatter() {
                    return `<div class="pieChart-legend" title="${this.name}">
                                            <span class="legend-text">
                                                <img class="item-marker" src="${ChartMarkerService.createMarkerSrc(
                                                    this.color,
                                                )}" />
                                                <span class="legend-name-branded">${this.name}</span>
                                            </span>&nbsp<span class="legend-value">${
                                                options.format && options.format === "number"
                                                    ? abbrNumberFilter()(this.y, true)
                                                    : // @ts-expect-error FIXME: Argument of type 'number' is not assignable to parameter of type 'boolean'
                                                      format(this.percentage, 2) + "%"
                                            }</span>
                                        </div>`;
                },
            },
            exporting: {
                enabled: false,
                chartOptions: {
                    chart: {
                        margin: [80, 150, 80, 150],
                        spacing: 10,
                    },
                    legend: {
                        enabled: true,
                        margin: 50,
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: true,
                            },
                        },
                    },
                },
            },
            tooltip: {
                formatter(): any {
                    if (options.format && options.format === "number") {
                        return this.key + "<br /><b>" + abbrNumberFilter()(this.y, true) + "</b>";
                    } else {
                        // @ts-expect-error FIXME: Argument of type 'number' is not assignable to parameter of type 'boolean'
                        return this.key + "<br /><b>" + format(this.percentage, 2) + "%</b>";
                    }
                },
            },
            plotOptions: {
                pie: {
                    animation: false,
                    showInLegend: true,
                    allowPointSelect: true,
                    innerSize,
                    size,
                    shadow: false,
                    cursor: "pointer",
                    slicedOffset: 2,
                    dataLabels: {
                        enabled: false,
                        color: "#000000",
                        connectorColor: "#000000",
                        formatter() {
                            // @ts-expect-error FIXME: Argument of type 'number' is not assignable to parameter of type 'boolean'
                            return "<b>" + this.point.name + "</b>: " + format(this.percentage, 2) + " %";
                        },
                    },
                    states: {
                        hover: {
                            halo: {
                                size: 7,
                                opacity: 0.25,
                            },
                        },
                    },
                },
                series: {
                    events: {
                        mouseOut() {
                            if (timeoutId) {
                                clearTimeout(timeoutId);
                            }
                            timeoutId = setTimeout(function () {
                                $(".pieChart-legend").removeClass("front1 front2 back1 back2");
                            }, 500);
                        },
                    },
                },
            },
        }, // allow overriding any chart config setting.
    };
};

export const OrganicBrandedNonBranded = (props) => {
    const { queryParams, noDataState, setNoDataState, routingParams, getCtaLink, unlockHook } = props;
    const [response, setResponse] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const endpoint = EndPoint;
    const isAfterTrialUser = isAfterTrial();
    const { selectorHandlers } = useSelectorTrigger("wwo-branded-non-branded");
    const setData = () => {
        if (isAfterTrialUser) {
            setIsLoading(false);
            return;
        }
        const fetchService = DefaultFetchService.getInstance();
        const { forAPI: lastMonthForAPI } = durationService.getDurationData(BasicDurations.LAST_MONTH);
        const getParams = {
            ...queryParams,
            from: lastMonthForAPI.from,
            to: lastMonthForAPI.to,
            isWindow: lastMonthForAPI.isWindow,
            timeGranularity: MonthlyTimeGranularity,
            duration: BasicDurations.LAST_MONTH,
        };
        const visitsDataPromise = fetchService.get(endpoint, getParams);
        visitsDataPromise.then(({ Data }) => parseResult(Data)).finally(() => setIsLoading(false));
    };
    React.useEffect(setData, [queryParams, isAfterTrialUser]);

    const parseResult = (result) => {
        if (!result || !result[queryParams.keys]) {
            return;
        }
        const items = [
            {
                name: i18nFilter()("wwo.searchTraffic.organic.pie.branded"),
                y: result[queryParams.keys].Branded,
                color: mainColors.acquire(),
            },
            {
                name: i18nFilter()("wwo.searchTraffic.organic.pie.notBranded"),
                y: result[queryParams.keys].NoneBranded,
                color: mainColors.acquire(),
            },
        ];
        const data = [{ data: items, name: `${queryParams.keys}` }];
        const config = pie("", data);
        setResponse(config);
    };

    const isNoDataState = !response || Object.values(response).length === 0;
    const href = getCtaLink(routingParams);

    React.useEffect(() => {
        if (isNoDataState !== noDataState.BrandedNonBranded) {
            setNoDataState({
                ...noDataState,
                BrandedNonBranded: isNoDataState,
            });
        }
    }, [isLoading]);

    const subtitleFilters = generateLastMonthSubtitleFilters(
        queryParams.country,
        queryParams.webSource,
        selectorHandlers,
    );
    const afterTrialContent = (
        <div style={{ height: "180px" }}>
            <BackgroundImageComponent
                images={[{ maxWidth: 2480, imageUrl: "/images/website-performance/single/branded_L.png" }]}
            />
        </div>
    );

    return (
        <div>
            <ComponentContainer style={{ padding: "24px" }}>
                <TitleContainer>
                    <BoxTitle tooltip={i18nFilter()(ToolTipKey)}>{i18nFilter()(TitleKey)}</BoxTitle>
                </TitleContainer>
                {isLoading ? (
                    <TableLoader />
                ) : isNoDataState && !isAfterTrialUser ? (
                    <NoData paddingTop={"66px"} />
                ) : (
                    <div>
                        <StyledSubtitle filters={subtitleFilters} />
                        {isAfterTrialUser ? (
                            afterTrialContent
                        ) : (
                            <Chart
                                type="pie"
                                data={response.series}
                                config={response.options}
                            />
                        )}
                        <WidgetFooter
                            {...href}
                            trackingLabel={ButtonTrackingText}
                            text={CtaButtonText}
                            unlockHook={unlockHook}
                        />
                    </div>
                )}
            </ComponentContainer>
        </div>
    );
};
